import { render, staticRenderFns } from "./supplier-invite.vue?vue&type=template&id=62f09202"
import script from "./supplier-invite.vue?vue&type=script&lang=js"
export * from "./supplier-invite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports